export enum Offer_type {
    ACCOUNTING_STARTER = 0,
    ACCOUNTING_BASIC = 1,
    ACCOUNTING_ESSENTIAL = 2,
    ACCOUNTING_PREMIUM = 3,
    BUSINESS_BASIC = 4,
    BUSINESS_ESSENTIAL = 5,
    BUSINESS_PREMIUM = 6,
    TRAINING = 7,
    BUSINESS_SMART = 8,
}
